import { Route, Routes } from 'react-router-dom';
import StellaDetails from './StellaDetails';


export default function StellaRouter() {
  return (
    <Routes>
      <Route path="/:name" element={<StellaDetails />} />
    </Routes>
  );
}
